<template>
  <div class="Menue">
    <CellGroup @on-click="HandleClick">
        <Cell title="退出登录" class="item-hover" name="Logout"/>
    </CellGroup>
  </div>
</template>

<script>
export default {
  name: 'UserInfoMenu',
  methods: {
    HandleClick (name) {
      if (name === 'Logout') {
        sessionStorage.clear()
        // localStorage.clear()
        this.$store.commit('setIsLogin', false)
        this.$store.commit('setToken', '')
        this.$store.commit('setTopMenu', [])
        this.$store.commit('setUserInfo', {})
        this.$store.commit('MenuList', [])
        this.$router.push({ name: 'SignIn' })
      }
    }
  }
}
</script>

<style scoped>
.Menue{
    top:2.8rem;
    right: 1rem;
    position: absolute;
    width: 6rem;
    background: #ffffff;
    border-radius: .5rem;
    box-shadow: 0 1px 6px rgba(0,0,0,.2);
}
  /*.#f0faff */
.item-hover:hover{
    background: #f0faff
}
</style>
